import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";
import {
  BaoCaoSvg,
  ChungSvg,
  CongVanSvg,
  CRMSvg,
  NhanSuSvg,
  TaiChinhSvg,
  TaiSanSvg,
} from "assets/svg/icon";

export const APP_NAME = "Hệ thống Y Tế Medic";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const CDHA_PREFIX_PATH = "/crm";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "vi",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};

export const SYSTEM_SCOPE_ID = {
  Hr: 1, // Nhan su
  Crm: 2, // Khac hang
  His: 3, // HIS
  Identity: 4, // Phan quyen - common
  Common: 5, // Phan quyen - common
  Project: 6, // cong van - cong viec
  Sale: 7, // Mua bán hàng
  // Report: 8, // Bao cao quan tri,
  Finance: 9, // Tài chính kế toán
  Asset: 10, // tai san
};
export const SYSTEM_SCOPE = [
  {
    value: SYSTEM_SCOPE_ID.Hr,
    label: "Nhân sự",
    icon: NhanSuSvg,
    disable: false,
    path: "/app/hrm",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Crm,
    label: "Khách hàng",
    icon: CRMSvg,
    disable: false,
    path: "/app/crm",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Project,
    label: "Công việc",
    icon: CongVanSvg,
    disable: false,
    path: "/app/project",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Asset,
    label: "Tài sản",
    icon: TaiSanSvg,
    disable: false,
    path: "/app/asset",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Sale,
    label: "SALE",
    icon: BaoCaoSvg,
    disable: false,
    path: "/app/sale",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Finance,
    label: "FINANCE",
    icon: TaiChinhSvg,
    disable: false,
    path: "/app/finance",
    hasDocument: true,
  },
  {
    value: SYSTEM_SCOPE_ID.Identity,
    label: "Thiết lập",
    icon: ChungSvg,
    disable: false,
    path: "/app/common",
    hasDocument: false,
  },
];

export const DETAIL_PAGE_PATH = `${APP_PREFIX_PATH}/common/detail-page`;
export const SIGN_REPORT_PATH = `${APP_PREFIX_PATH}/common/tong-hop-ky`;
export const NOTIFICATION_REPORT_PATH = `${APP_PREFIX_PATH}/common/tong-hop-thong-bao`;
